import { HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApolloLink } from '@apollo/client';
import { DateTime } from 'luxon';
import { Session } from '../session/session.service';

/**
 * @description Headers.
 * @exports
 * @returns {ApolloLink}
 */
export function headers(): ApolloLink {
  const session = inject(Session);

  return new ApolloLink((operation, forward) => {
    const context = operation.getContext();

    const datetime = DateTime.now();
    const timezone = datetime.zoneName;

    const lang = context['contentLanguage'] ?? session.lang;
    const token = context['token'];

    let headers = new HttpHeaders({
      'Content-Language': lang,
      /*
       * Prefer: timezone=<IANA_Timezone_Name>
       *
       * This header informs the server of the client's timezone preference
       * for date-time related data handling.
       * The server can utilize this information to adjust date-time values
       * in responses according to the specified timezone.
       * Ensure the server is configured to recognize and process this header appropriately.
       *
       * @example
       * Prefer: timezone=Asia/Jakarta
       *
       * @see {@link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Prefer
       */
      Prefer: `timezone=${timezone}`
    });

    // If a token is provided, add the Authorization header
    if (token) {
      headers = headers.append('Authorization', `Bearer ${token}`);
    }

    operation.setContext({ headers });

    return forward(operation);
  });
}
